<template>
  <div class="topup-phone">
    <topup-phone-breadcrumbs />
    <topup-phone-step1 v-if="isCurrentStep(1)" />
    <topup-phone-step2 v-if="isCurrentStep(2)" />
  </div>
</template>

<script>
import TopupPhoneBreadcrumbs from '@/doladujtutaj/components/TopupPhone/Breadcrumbs'
import TopupPhoneStep1 from '@/doladujtutaj/components/TopupPhone/Step1'
import TopupPhoneStep2 from '@/doladujtutaj/components/TopupPhone/Step2'
import ProgressMixin from '@/common/mixins/Topup/Progress.mixin'
import { ToolsClass } from '@/common/class/tools.class'

export default {
  name: 'TopupPhoneView',
  mixins: [ProgressMixin],
  components: {
    TopupPhoneStep2,
    TopupPhoneStep1,
    TopupPhoneBreadcrumbs
  },
  mounted () {
    ToolsClass.sendHeightToIframeParent()
    window.addEventListener('resize', ToolsClass.sendHeightToIframeParent)
  },
  updated () {
    ToolsClass.sendHeightToIframeParent()
  }
}
</script>
